import React from 'react';
import { CampusPage } from './pages/CampusPage';
import { JoinThinkTechPage } from './pages/JoinThinkTechPage';
import { FAQPage } from './pages/FAQPage';
import { ThinkTechEventPage } from './pages/ThinkTechEventPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';

function App() {
  // Simple routing based on pathname
  const currentPath = window.location.pathname;
  
  const renderPage = () => {
    switch (currentPath) {
      case '/joinThinkTech':
        return <JoinThinkTechPage />;
      case '/FAQ':
        return <FAQPage />;
      case '/thinktech':
      case '/ThinkTech':
        return <ThinkTechEventPage />;
      case '/privacy-policy':
        return <PrivacyPolicyPage />;
      default:
        return <CampusPage />;
    }
  };

  return (
    <div className="min-h-screen">
      {renderPage()}
    </div>
  );
}

export default App;